import React, { useEffect, useState } from "react";
// import "./ExistingHutchForm.css";
import { Link, useNavigate } from "react-router-dom";
import BASE_URL, { API_KEY, PAYLOAD_SECRET } from "../../../config";
import { useProcessContext } from "../../context/ProcessContext";
import { BallTriangle } from "react-loader-spinner";

const OdooshCode = () => {
    const { centerAlert, userData, encryptData } = useProcessContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        // const type = params.get("type");
        const type = localStorage.getItem('type');

        if (code && type) {
            handleNavigation(code, type);
        } else {
            centerAlert("error", "Missing code or type");
        }

    }, []);

    const handleNavigation = (code, type) => {
        setLoading(true);

        if (type === "login") {
            navigate(`/?code=${encodeURIComponent(code)}&type=${encodeURIComponent(type)}`);
        } else if (type === "authorize") {
            navigate(`/configuration/odoo-sh?code=${encodeURIComponent(code)}&type=${encodeURIComponent(type)}`);
        } else {
            centerAlert("error", "Invalid type parameter");
        }
        setLoading(false);
    };


    return (
        <div
            className="d-flex flex-column align-items-center"
            style={{ width: "100%", height: "100%", backgroundColor: "white" }}
        >
            {loading && (
                <div
                    className="progress_bar_checkin"
                    style={{ width: "350px", height: "250px", top: "40%" }}
                >
                    {/* Loading */}
                    <h3>Processing...</h3>
                    {/* <ProgressBar progress={progress} /> */}
                    <BallTriangle
                        height={100}
                        width={100}
                        radius={5}
                        color="#1a7e8f"
                        ariaLabel="ball-triangle-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                    />
                </div>
            )}
        </div>
    );
};

export default OdooshCode;
